import classNames from 'classnames'
import { getPbgidIcon, usePbgidIcons } from '../helpers/pbgidIcons'

export function UnitShowcase({ icon, name }) {
	const pbgidIcons = usePbgidIcons()
	const _icon = typeof icon === 'number' ? getPbgidIcon(pbgidIcons, icon) || '/liveGameIcons/unknown.png' : icon

	return (
		<div className={classNames('unitShowcase flex flex-row ')}>
			<div
				className=""
				style={{
					backgroundRepeat: 'no-repeat',
					backgroundSize: '100% 100%',
					backgroundImage: `url(/liveGameIcons/military_background.png)`,
				}}>
				<img className="w-10 h-10" src={_icon} alt="" />
			</div>
			<h1 className="unitShowcase__name">{name}</h1>
		</div>
	)
}
